//ProgressList.tsx
import * as React from 'react';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import ApplicationProgress from './ApplicationProgress';
import { getProgressInquiries } from '../../../../service/HomePage/ProgressInquiryService';
import { ProgressInquiryType } from './ProgressInquiryType';
import { useUser } from '../../../../context/UserContext';
import theme from '../../../../style/theme';
import { useMediaQuery } from '@mui/material';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

/**
 * 申請中一覧コンポーネント
 * - ログインユーザーが申請中の申請をカード形式で一覧表示する
 * - 申請日の降順にソートして表示し、クリックで申請詳細画面に遷移する
 */
export default function ProgressList() {

  const [progressData, setProgressData] = useState<ProgressInquiryType[]>([]);
  const { user } = useUser(); // useUser フックを使ってユーザー情報を取得
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');  // 600px 以下でモバイル表示

  // 初期表示時にサーバーから申請中データを取得する
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user && user.id){ 
        const data = await getProgressInquiries();
        setProgressData(data);
      } else {
        console.error("ユーザー情報が取得できませんでした");
      }
      } catch (error) {
        console.error("Error fetching progress inquiries:", error);
      }
    };

    fetchData();
  }, []);

  // 申請日の降順でソートする（未提出の場合は最後尾）
  const sortedData = [...progressData].sort((a, b) => {
    const dateA = a.submittedAt ? new Date(a.submittedAt).getTime() : 0;
    const dateB = b.submittedAt ? new Date(b.submittedAt).getTime() : 0;
    return dateB - dateA;
  });
  // 遷移後画面
  const handleCardClick = (record: ProgressInquiryType) => {
    navigate(`/detail/${record.id}`, {
      state: { ...record },
    });
  };
  return (
    <Box>
      <Card variant="elevation"
        sx={{
          boxShadow: 2, // 影効果
          borderRadius: 1, //枠の角を丸くさせる
          overflow: 'hidden',
          background: theme.palette.secondary.main
        }}>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}>
          <Typography variant="h2" sx={{ px: 2, py: 1 }}>申請中</Typography>
          <Chip label={`${progressData.length}件`}
            sx={{
              mr: 1, maxHeight: '25px',
              bgcolor: theme.palette.custom.lightGreen,fontWeight: 'bold',
            }}
            variant='largeText' />
        </Box>
        <Divider />

    <ResizableBox
      width={Infinity}
      height={200}
      minConstraints={[Infinity, 200]}
      maxConstraints={[Infinity, 600]}
      resizeHandles={['se']} // 右下の角でリサイズ
    >
        {/* ListとListItemの高さを固定にする */}
        <Box
          sx={{
            width: '100%',
            height: '100%',
            overflowY: 'auto',
            padding: 0,
            minHeight: '200px',
            resize: "vertical",
          }}
        >

          <List
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              background: theme.palette.secondary.main,
              p: 1,
            }}
          >
            {sortedData.map((data) => (             
              <Card
                key={data.id}
                onClick={() => handleCardClick(data)}
                sx={{
                  width: '100%',
                  cursor: 'pointer',
                  boxShadow: 1,
                  px:1,
                  py: 0.5,
                  transition: 'box-shadow 0.2s',
                  '&:hover': {
                    boxShadow: 4,
                  },
                  maxHeight: isMobile ? 'none' : '200px',
                  overflow: 'auto',
                  whiteSpace: 'nowrap',
                }}
              >  
              <Box sx={{ display: 'inline-block', minWidth: '100%' }}>     
                <ApplicationProgress data={data} />
                </Box>  
              </Card>
            ))}
          </List>
        </Box>
    </ResizableBox>

        <Divider />


        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Link to="/ProgressInquiry">
            <Button
              variant="contained"
              color="primary"
              sx={{ m: 0.5}}
            >
              申請履歴
            </Button>
          </Link>
        </Box>
      </Card>
    </Box>
  );
}